import * as XLSX from 'xlsx';
import { Dispute } from '../types/dispute';

export const exportDisputes = (disputes: Dispute[]) => {
  try {
    const rows = disputes.map(dispute => ({
      'Pilgrim Name': dispute.pilgrimName,
      'Passport Number': dispute.passportNumber,
      'Email': dispute.pilgrimEmail || '-',
      'Phone': dispute.pilgrimPhone || '-',
      'Country': dispute.pilgrimCountry,
      'Disputing Organizers': dispute.disputingGuides.map(g => g.organizerName).join(' | '),
      'Related Guides': dispute.disputingGuides.map(g => g.guideName).join(' | '),
      'Status': dispute.status === 'pending' ? 'Pending' :
               dispute.status === 'under_processing' ? 'Under Processing' :
               'Resolved',
      'Created At': new Date(dispute.createdAt).toLocaleString(),
      'Updated At': new Date(dispute.updatedAt).toLocaleString(),
      'Evidence Submitted': dispute.disputingGuides.filter(g => g.hasSubmittedEvidence || g.evidence).length,
      'Resolved Organizer': dispute.resolvedOrganizerId ? dispute.disputingGuides.find(g => (g.organizerId || g.guideId) === dispute.resolvedOrganizerId)?.organizerName : '-',
      'Resolved Guide': dispute.resolvedGuideId ? dispute.disputingGuides.find(g => g.guideId === dispute.resolvedGuideId)?.guideName : '-',
      'Resolved At': dispute.resolvedAt ? new Date(dispute.resolvedAt).toLocaleString() : '-'
    }));

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(rows);

    // Set column widths
    ws['!cols'] = [
      { wch: 30 }, // Pilgrim Name
      { wch: 15 }, // Passport
      { wch: 25 }, // Email
      { wch: 15 }, // Phone
      { wch: 20 }, // Country
      { wch: 50 }, // Disputing Organizers
      { wch: 50 }, // Related Guides
      { wch: 15 }, // Status
      { wch: 20 }, // Created At
      { wch: 20 }, // Updated At
      { wch: 15 }, // Evidence Submitted
      { wch: 25 }, // Resolved Organizer
      { wch: 25 }, // Resolved Guide
      { wch: 20 }, // Resolved At
    ];

    // Create workbook and append worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Disputes');

    // Generate filename with current date
    const date = new Date().toISOString().split('T')[0];
    const filename = `disputes-report-${date}.xlsx`;

    // Save file
    XLSX.writeFile(wb, filename);

    return true;
  } catch (error) {
    console.error('Error exporting disputes:', error);
    return false;
  }
};
